const styles = (theme) => ({
  logo: {
    width: "auto",
    height: "20px",
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1, // garante que fique sobreposto ao Paper
  },
  containerPaper: {
    borderRadius: 3,
    minWidth: "200px",
    padding: "10px",
    display: "flex",
    flexDirection: "column",

    gap: 1,
    position: "relative", // necessário para o posicionamento do ícone decorativo
    overflow: "hidden",
  },
  titleCard: {
    fontWeight: "bold",
    fontSize: "12px",
    color: theme.palette.white.main,
  },
  containerTitle: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
  },
  title: {
    left: "50%",

    whiteSpace: "nowrap",
    fontWeight: "bold",
  },
  status: {
    width: "7px",
    height: "7px",
    marginLeft: "auto",
    borderRadius: "50%",
    backgroundColor: theme.palette.colors.green.light, // Verde, pode ser alterado
    boxShadow: `0 0 5px ${theme.palette.colors.green.light}`,
    animation: "pulse 1.8s infinite ease-in-out",
    "@keyframes pulse": {
      "0%": {
        opacity: 0.4,
        boxShadow: `0 0 5px ${theme.palette.colors.green.light}`,
      },
      "50%": {
        opacity: 1,
        boxShadow: `0 0 15px ${theme.palette.colors.green.light}`,
      },
      "100%": {
        opacity: 0.4,
        boxShadow: `0 0 5px ${theme.palette.colors.green.light}`,
      },
    },
  },
  containerIconCard: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    padding: 3,
  },
  containerData: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
  },
  titleValue: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.palette.colors.green.light,
  },
  titleData: {
    fontSize: "13px",
    color:
      theme.palette.mode == "dark"
        ? theme.palette.colors.black.light
        : theme.palette.colors.black.medium,
  },
  containerBodyCard: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    gap: 2,
  },
  container: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "75px",
    justifyContent: "left",
  },
  clickablePaper: {
    cursor: "pointer",
    transition:
      "transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease",
    "&:hover": {
      transform: "scale(1.02)",
      boxShadow: `0 6px 20px rgba(0,0,0,0.18)`,
      "&::after": {
        content: '""',
        position: "absolute",
        inset: 0,
        borderRadius: 3,
        background:
          theme.palette.mode === "dark"
            ? "rgba(255,255,255,0.08)"
            : "rgba(0,0,0,0.03)",
        pointerEvents: "none",
      },
    },
  },
});

export default styles;
